import * as React from "react";
import { useId } from "@floating-ui/react";
import { ResizeObserver } from "@juggle/resize-observer";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Badge } from "../badge/badge.mjs";
import { Button } from "../button/button.mjs";
import { Card } from "../card/card/card.mjs";
import { CardContent } from "../card/card-content/card-content.mjs";
import { CardTop } from "../card/card-top/card-top.mjs";
import { ClickArea } from "../helpers/click-area/click-area.mjs";
import { ClickAreaTrigger } from "../helpers/click-area/click-area-trigger.mjs";
import { EqualHeight } from "../equal-height/equal-height/equal-height.mjs";
import { FormHelper } from "../form/form-helper/form-helper.mjs";
import { Grid } from "../grid/grid/grid.mjs";
import { GridColumn } from "../grid/grid-column/grid-column.mjs";
import { Heading } from "../typography/heading/heading.mjs";
import { Icon } from "../icon/icon/icon.mjs";
import { Image } from "../image/image.mjs";
import { InputContext } from "../helpers/input-provider/input-provider.mjs";
import { List } from "../list/list/list.mjs";
import { ListItem } from "../list/list-item/list-item.mjs";
import { ObjectFit } from "../object-fit/object-fit.mjs";
import { Select } from "../form/select/select.mjs";
import { Selector } from "../form/selector/selector.mjs";
import { Tag } from "../tag/tag.mjs";
import { TagGroup } from "../tag-group/tag-group.mjs";
import { Tooltip } from "../tooltip/tooltip.mjs";
import { TooltipToggle } from "../tooltip-toggle/tooltip-toggle.mjs";
const ProductCard = React.forwardRef(function ProductCard2(props, ref) {
  var _a;
  const { input } = React.useContext(InputContext);
  const id = (_a = useId()) != null ? _a : "";
  return /* @__PURE__ */ React.createElement(ProductCardInner, { ...props, input, id, linkRef: ref });
});
class ProductCardInner extends React.Component {
  constructor(props) {
    super(props);
    this.figureRef = null;
    this.resizeObserver = null;
    this.handleResize = () => {
      const element = this.elementRef.current;
      if (element) {
        const elementWidth = element.offsetWidth;
        if (elementWidth !== this.state.elementWidth) {
          this.setState({ elementWidth });
        }
      }
    };
    this.handleCompareMouseEnter = () => {
      if (this.state.hover !== "compare") {
        this.resetProperties();
        this.setFigureStyleProperty("transform", "translateX(-60px)");
        this.setState({
          hover: "compare"
        });
      }
    };
    this.handleCompareMouseLeave = () => {
      if (this.state.hover === "compare") {
        this.resetProperties();
        this.setState({
          hover: null
        });
      }
    };
    this.handleColorMouseEnter = (value) => {
      if (this.state.color !== value) {
        this.setState({
          color: value
        });
      }
    };
    this.handleColorMouseLeave = (value) => {
      if (this.state.color === value) {
        this.setState({
          color: null
        });
      }
    };
    this.handleColorMouseClick = (value) => {
      this.setState({
        color: value
      });
    };
    this.elementRef = React.createRef();
    this.state = {
      color: null,
      figureStyle: {},
      hover: null,
      memory: null,
      elementWidth: 0
    };
  }
  componentDidMount() {
    this.handleResize();
    this.resizeObserver = new ResizeObserver(() => {
      this.handleResize();
    });
    if (this.elementRef.current) {
      this.resizeObserver.observe(this.elementRef.current);
    }
  }
  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
  resetProperties() {
    this.setFigureStyleProperty("transform", "translateX(0)");
  }
  setFigureStyleProperty(property, value) {
    this.setState((prevState) => {
      return {
        figureStyle: {
          ...prevState.figureStyle,
          [property]: value
        }
      };
    });
  }
  getImageProps() {
    const { color } = this.state;
    const { colors } = this.props;
    if (colors && Array.isArray(colors)) {
      if (color) {
        const currentColor2 = colors.find((c) => c.label === color);
        if (currentColor2 && currentColor2.image) {
          return currentColor2.image;
        }
      }
      const currentColor = colors.find((c) => c.isCurrent);
      if (currentColor && currentColor.image) {
        return currentColor.image;
      }
    }
    return this.props.image;
  }
  getCurrentColor() {
    const { color } = this.state;
    const { colors } = this.props;
    if (colors && Array.isArray(colors)) {
      if (color) {
        return colors.find((c) => c.label === color);
      }
      return colors.find((c) => c.isCurrent);
    }
    return void 0;
  }
  getCurrentColorLabel() {
    var _a;
    return ((_a = this.getCurrentColor()) == null ? void 0 : _a.label) || "";
  }
  BEM() {
    const classArray = ["product-card"];
    if (this.state.hover) {
      classArray.push("product-card--hover-" + this.state.hover);
    }
    if (this.props.inactive) {
      classArray.push("product-card--inactive");
    }
    if (this.props.type) {
      classArray.push("product-card--type-".concat(this.props.type));
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  footerBEM() {
    const FOOTER_MIN_WIDTH = 260;
    const classArray = ["product-card__footer"];
    if (this.state.elementWidth <= FOOTER_MIN_WIDTH) {
      classArray.push("product-card__footer--narrow");
    }
    return classArray.join(" ");
  }
  getTags(tags, index) {
    var _a;
    if (!Array.isArray(tags)) {
      return this.renderTags(tags, "".concat((_a = tags.tooltip) == null ? void 0 : _a.id, "--").concat(index));
    } else {
      return this.renderTags(tags);
    }
  }
  renderTags(tags, id) {
    let content;
    const responsiveProps = [
      {
        breakPoint: "xs",
        props: {
          size: "small",
          fontSize: "small"
        }
      },
      {
        breakPoint: "sm",
        props: {
          size: "medium",
          fontSize: "medium"
        }
      },
      {
        breakPoint: "md",
        props: {
          size: "large",
          fontSize: "large"
        }
      }
    ];
    if (Array.isArray(tags)) {
      const isCustomResponsive = tags.some((tag) => tag.responsive);
      const modifiedTags = tags.map((tag) => {
        if (!this.props.tagGroupSize && !isCustomResponsive) {
          return {
            ...tag,
            responsive: responsiveProps
          };
        }
        return {
          ...tag
        };
      });
      content = /* @__PURE__ */ React.createElement(TagGroup, { tags: modifiedTags, size: this.props.tagGroupSize });
    } else {
      let tagProps = {
        className: "product-card__tag",
        ...tags
      };
      if (!tags.size && !tags.responsive) {
        tagProps = {
          responsive: responsiveProps,
          ...tagProps
        };
      }
      if (tags.tooltip && id) {
        content = /* @__PURE__ */ React.createElement(Tag, { ...tagProps, tooltip: { id, children: tags.tooltip.children } });
      } else {
        content = /* @__PURE__ */ React.createElement(Tag, { ...tagProps });
      }
    }
    return /* @__PURE__ */ React.createElement("div", { className: "product-card__tags" }, content);
  }
  renderTag(tag) {
    return /* @__PURE__ */ React.createElement(Tag, { ...tag, size: "tiny" });
  }
  getUrl() {
    var _a;
    const { url: productUrl } = this.props;
    const currentColor = this.getCurrentColor();
    const currentMemory = this.getCurrentMemory();
    if (currentColor && currentMemory && Array.isArray(currentColor.url)) {
      return ((_a = currentColor.url.find((url) => url.memory === currentMemory.value)) == null ? void 0 : _a.value) || productUrl;
    }
    return !Array.isArray(currentColor == null ? void 0 : currentColor.url) && (currentColor == null ? void 0 : currentColor.url) || (currentMemory == null ? void 0 : currentMemory.url) || productUrl;
  }
  getCurrentMemory() {
    var _a;
    const { memories } = this.props;
    if (!((_a = memories == null ? void 0 : memories.items) == null ? void 0 : _a.length)) {
      return void 0;
    }
    if (this.state.memory) {
      return memories.items.find((memory) => memory.value === this.state.memory);
    }
    return memories.items.find((memory) => memory.isCurrent);
  }
  getPrice(type) {
    const price = this.props[type];
    const currentMemory = this.getCurrentMemory();
    return currentMemory ? currentMemory[type] : price;
  }
  renderMonthlyPrice(monthlyPrice) {
    return /* @__PURE__ */ React.createElement("div", { className: "product-card__monthly-price-inner" }, /* @__PURE__ */ React.createElement("p", { className: "text-tiny text-primary" }, monthlyPrice.label), /* @__PURE__ */ React.createElement("p", { className: "product-card__price" }, this.props.tax ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "product-card__price-text" }, this.getPriceAsString(monthlyPrice.price)), /* @__PURE__ */ React.createElement("span", null, " "), /* @__PURE__ */ React.createElement("span", { className: "product-card__tax-text" }, this.props.tax)) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.getPriceAsString(monthlyPrice.price))), monthlyPrice.tagText && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Tag,
      {
        className: "product-card__price-tag",
        size: "tiny",
        text: monthlyPrice.tagText,
        purpose: monthlyPrice.tagPurpose,
        isDisabled: this.props.inactive
      }
    ), " "), /* @__PURE__ */ React.createElement("span", { className: "text-tiny text-light product-card__price-months" }, monthlyPrice.length));
  }
  getPriceAsString(price) {
    if (typeof price === "string") {
      return price;
    }
    return "".concat(price.value, " ").concat(price.unit);
  }
  renderPriceAsValue(price) {
    if (typeof price === "string") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, this.getPriceAsString(price));
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, price.value, " " + price.unit);
  }
  renderPrice() {
    const price = this.getPrice("price");
    const previousPrice = this.getPrice("previousPrice");
    if (price && previousPrice) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: "text-tiny text-primary" }, price.label), /* @__PURE__ */ React.createElement("p", { className: "product-card__discount-price" }, this.props.tax ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "product-card__price-text" }, this.renderPriceAsValue(price.price)), /* @__PURE__ */ React.createElement("span", null, " "), /* @__PURE__ */ React.createElement("span", { className: "product-card__tax-text" }, this.props.tax)) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderPriceAsValue(price.price))), price.priceEndDate && price.priceEndDateLabel && /* @__PURE__ */ React.createElement("p", { className: "text-tiny text-light" }, price.priceEndDateLabel + " ", " ", /* @__PURE__ */ React.createElement("time", { dateTime: price.priceEndDate.isoDate }, price.priceEndDate.formattedDate)), /* @__PURE__ */ React.createElement("p", { className: "text-tiny text-light" }, previousPrice.label + " ", previousPrice.ignoreCrossOut ? /* @__PURE__ */ React.createElement("strong", null, this.getPriceAsString(previousPrice.price), this.props.tax && /* @__PURE__ */ React.createElement(React.Fragment, null, " ".concat(this.props.tax))) : /* @__PURE__ */ React.createElement("del", null, /* @__PURE__ */ React.createElement("strong", null, this.getPriceAsString(previousPrice.price), this.props.tax && /* @__PURE__ */ React.createElement(React.Fragment, null, " ".concat(this.props.tax))))));
    } else if (price) {
      return /* @__PURE__ */ React.createElement("div", { className: "product-card__price-inner" }, /* @__PURE__ */ React.createElement("p", { className: "text-tiny text-primary" }, price.label), /* @__PURE__ */ React.createElement("p", { className: "product-card__current-price" }, this.props.tax ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "product-card__price-text" }, this.renderPriceAsValue(price.price)), /* @__PURE__ */ React.createElement("span", null, " "), /* @__PURE__ */ React.createElement("span", { className: "product-card__tax-text" }, this.props.tax)) : /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderPriceAsValue(price.price))));
    }
    return null;
  }
  renderMemories(memories) {
    const { items, ...rest } = memories;
    const currentMemory = this.getCurrentMemory();
    return /* @__PURE__ */ React.createElement(
      Selector,
      {
        ...rest,
        items: memories.items.map((memory) => ({
          id: memory.id,
          value: memory.value,
          name: memory.id,
          label: memory.label,
          ariaLabel: memory.ariaLabel,
          onChange: memory.onClick
        })),
        align: "left",
        value: currentMemory == null ? void 0 : currentMemory.value,
        onChange: (value) => this.setState({ memory: value }),
        hideLabel: true,
        size: "small",
        className: "product-card__memory-selector"
      }
    );
  }
  renderColorSelect(colors) {
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        ...colors,
        className: "product-card__color-select",
        size: "small",
        hideLabel: "no-break",
        simpleValue: true,
        options: colors.options.map((option) => {
          const { color, ...rest } = option;
          return {
            ...rest,
            children: /* @__PURE__ */ React.createElement(Grid, { noWrap: true, gutter: "small", verticalGutter: "none", align: ["middle-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(
              "div",
              {
                className: "product-card__color-inner",
                style: {
                  background: color
                }
              }
            )), /* @__PURE__ */ React.createElement(GridColumn, { width: ["max"] }, rest.label))
          };
        })
      }
    );
  }
  renderColors(colors) {
    const { input } = this.props;
    const { color: currentColor } = this.state;
    if (!Array.isArray(colors)) {
      return this.renderColorSelect(colors);
    }
    const label = this.getCurrentColorLabel();
    return /* @__PURE__ */ React.createElement("div", { className: "product-card__colors" }, colors.map((color, index) => {
      const colorStyle = {
        background: color.color
      };
      const mouseEnterHandler = () => {
        if (color.label && color.image) {
          this.handleColorMouseEnter(color.label);
        }
      };
      const mouseLeaveHandler = () => {
        if (color.label && color.image) {
          this.handleColorMouseLeave(color.label);
        }
      };
      const mouseClickHandler = () => {
        if (color.label && color.image) {
          this.handleColorMouseClick(color.label);
        }
      };
      const BEM = () => {
        const classArray = ["product-card__color"];
        if (currentColor && currentColor === color.label || !currentColor && color.isCurrent) {
          classArray.push("is-current");
        }
        return classArray.join(" ");
      };
      if (color.url) {
        return /* @__PURE__ */ React.createElement(
          Anchor,
          {
            key: index,
            className: BEM(),
            "aria-label": color.ariaLabel,
            url: this.getUrl(),
            onClick: mouseClickHandler || color.onClick,
            tabIndex: -1,
            attributes: {
              onMouseEnter: this.isMouseInput(input) ? mouseEnterHandler : void 0,
              onMouseLeave: this.isMouseInput(input) ? mouseLeaveHandler : void 0
            }
          },
          /* @__PURE__ */ React.createElement("div", { className: "product-card__color-inner", style: colorStyle }),
          /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, color.label)
        );
      }
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: index,
          className: BEM(),
          onMouseEnter: this.isMouseInput(input) ? mouseEnterHandler : void 0,
          onMouseLeave: this.isMouseInput(input) ? mouseLeaveHandler : void 0
        },
        /* @__PURE__ */ React.createElement("div", { className: "product-card__color-inner", style: colorStyle }),
        /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, color.label)
      );
    }), label && /* @__PURE__ */ React.createElement("div", { className: "product-card__color-label" }, label));
  }
  get titleId() {
    return "".concat(this.props.id, "-title");
  }
  renderTitle(title) {
    const { headingLevel = 1 } = this.props;
    return /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "h4 text-bold", id: this.titleId }, /* @__PURE__ */ React.createElement(ClickAreaTrigger, null, /* @__PURE__ */ React.createElement(Anchor, { url: this.getUrl(), onClick: this.props.onClick, isTextColor: true, isUnderlined: false, ref: this.props.linkRef }, title.brand && /* @__PURE__ */ React.createElement(React.Fragment, null, title.brand, " "), title.name, title.info && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", title.info))));
  }
  renderFooter() {
    var _a;
    const monthlyPrice = this.getPrice("monthlyPrice");
    return /* @__PURE__ */ React.createElement("div", { className: this.footerBEM() }, /* @__PURE__ */ React.createElement("div", { className: "product-card__footer--column-inner" }, /* @__PURE__ */ React.createElement("div", { className: "product-card__footer--column-left" }, /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-footer-left" }, monthlyPrice && this.renderMonthlyPrice(monthlyPrice))), /* @__PURE__ */ React.createElement("div", { className: "product-card__footer--column-right" }, /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-footer-right" }, this.renderPrice()))), /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-footer-button" }, this.props.cartButton && /* @__PURE__ */ React.createElement("div", { className: "product-card__cart-button-wrapper" }, /* @__PURE__ */ React.createElement(Button, { type: "expressive", iconLeft: "#cart", ...this.props.cartButton }), ((_a = this.props.cartButtonHelper) == null ? void 0 : _a.visible) && /* @__PURE__ */ React.createElement(FormHelper, { type: "valid", ...this.props.cartButtonHelper.options, className: "product-card__cart-button-helper" }))));
  }
  compareButtonBEM(compare) {
    const classArray = ["product-card__compare-button"];
    if (compare.isActive) {
      classArray.push("is-active");
    }
    return classArray.join(" ");
  }
  isMouseInput(input) {
    return input === "mouse";
  }
  renderCompareButton(compare) {
    const { input } = this.props;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: this.compareButtonBEM(compare),
        id: compare.id,
        type: "button",
        onClick: (e) => {
          var _a;
          e.stopPropagation();
          (_a = compare.onClick) == null ? void 0 : _a.call(compare, e);
        },
        onMouseEnter: input && this.isMouseInput(input) ? this.handleCompareMouseEnter : void 0,
        onMouseLeave: input && this.isMouseInput(input) ? this.handleCompareMouseLeave : void 0,
        "aria-labelledby": "".concat(compare.id, " ").concat(this.titleId)
      },
      /* @__PURE__ */ React.createElement("span", { className: "product-card__compare-button-inner" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#compare", className: "product-card__compare-button-icon" }), /* @__PURE__ */ React.createElement(Icon, { modifiers: "#plus", className: "product-card__compare-button-icon product-card__compare-button-icon--add" }), /* @__PURE__ */ React.createElement(Icon, { modifiers: "#minus", className: "product-card__compare-button-icon product-card__compare-button-icon--remove" }), compare.isActive && /* @__PURE__ */ React.createElement(Badge, { icon: "#check", purpose: "success", size: "small", className: "product-card__compare-button-active-icon" }), /* @__PURE__ */ React.createElement("span", { className: "product-card__compare-button-text" }, compare.text))
    );
  }
  renderInactiveContent() {
    const { inactiveContent } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: "product-card__inactive-content h4" }, inactiveContent);
  }
  renderContent() {
    var _a, _b, _c;
    const figureRef = (el) => this.figureRef = el;
    const hasTagOrCompare = !!((_a = this.props.tag) != null ? _a : this.props.compare);
    const getAltText = (title) => {
      const altText = [];
      if (title.brand) {
        altText.push(title.brand);
      }
      altText.push(title.name);
      if (title.info) {
        altText.push(title.info);
      }
      return altText.join(" ");
    };
    return /* @__PURE__ */ React.createElement(CardContent, { className: "product-card__content", elementRef: this.elementRef, padding: "small" }, /* @__PURE__ */ React.createElement(CardTop, null, /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-tag", className: hasTagOrCompare ? "product-card__top-content-wrapper" : "" }, hasTagOrCompare && /* @__PURE__ */ React.createElement("div", { className: "product-card__top-content" }, this.props.tag && this.renderTag(this.props.tag), this.props.compare && this.renderCompareButton(this.props.compare))), /* @__PURE__ */ React.createElement("div", { className: "product-card__figure-wrapper" }, this.props.tags && this.getTags(this.props.tags, "first"), /* @__PURE__ */ React.createElement("div", { className: "product-card__figure-inner" }, /* @__PURE__ */ React.createElement("figure", { className: "product-card__figure", style: this.state.figureStyle, ref: figureRef }, /* @__PURE__ */ React.createElement(Anchor, { url: this.getUrl(), tabIndex: -1, "aria-hidden": true, isUnderlined: false }, /* @__PURE__ */ React.createElement(ObjectFit, { fit: "contain", positionX: "center", positionY: "center", className: "product-card__image" }, /* @__PURE__ */ React.createElement(Image, { ...this.getImageProps(), isInactive: this.props.inactive, role: "img", alt: getAltText(this.props.title) }))), /* @__PURE__ */ React.createElement(Icon, { className: "product-card__image-compare-icon", modifiers: "#compare" }), /* @__PURE__ */ React.createElement(ObjectFit, { fit: "contain", positionX: "center", positionY: "center", className: "product-card__image product-card__image--copy" }, /* @__PURE__ */ React.createElement(Image, { ...this.getImageProps(), isInactive: this.props.inactive, role: "presentation" })), this.props.inactive && this.renderInactiveContent()))), /* @__PURE__ */ React.createElement("div", { className: "product-card__info" }, /* @__PURE__ */ React.createElement("div", { className: "product-card__info-inner" }, /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-colors" }, this.props.colors && this.renderColors(this.props.colors)), /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-title" }, this.renderTitle(this.props.title)), /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-memories" }, ((_c = (_b = this.props.memories) == null ? void 0 : _b.items) == null ? void 0 : _c.length) && this.renderMemories(this.props.memories)), /* @__PURE__ */ React.createElement(EqualHeight, { group: "product-card-features" }, this.props.features && this.renderFeatures(this.props.features)), (this.props.price || this.props.monthlyPrice || this.props.cartButton) && this.renderFooter()))));
  }
  renderFeatures(features) {
    return /* @__PURE__ */ React.createElement(
      List,
      {
        className: "product-card__features",
        type: features.some((feature) => feature.icon) ? "icon" : "unstyled",
        verticalSpacing: "none",
        iconPosition: "middle"
      },
      features.map((feature, index) => {
        const content = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "text-small" }, feature.name, " "), feature.info && /* @__PURE__ */ React.createElement("span", { className: "text-small" }, feature.info));
        return /* @__PURE__ */ React.createElement(ListItem, { key: index, icon: feature.icon, iconClassName: "product-card__feature-icon" }, feature.tooltip ? /* @__PURE__ */ React.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React.createElement(TooltipToggle, { id: feature.tooltip.id }, content), placement: "top" }, feature.tooltip.children) : content);
      })
    );
  }
  render() {
    return /* @__PURE__ */ React.createElement(ClickArea, null, /* @__PURE__ */ React.createElement(Card, { className: this.BEM(), background: "neutral-bg-level-1", type: "light", element: "article", "aria-labelledby": this.titleId }, this.renderContent()));
  }
}
export {
  ProductCard
};
